import { PRODUCTS_A } from './productsA';
import { PRODUCTS_B } from './productsB';
import { PRODUCTS_C } from './productsC';
import { PRODUCTS_D } from './productsD';
import { PRODUCTS_E } from './productsE';

export const PRODUCTS = { ...PRODUCTS_A, ...PRODUCTS_B, ...PRODUCTS_C, ...PRODUCTS_D, ...PRODUCTS_E };
